


























































































































































import Vue from 'vue'
import Button from '@/components/globals/Button.vue'
import {
  pushModalRankUpEvent,
  pushModalRankDownEvent,
  pushModalCompleteQuestEvent,
  pushModalWelcomeBackEvent,
} from '@/tools/gtm'
import { PartialAuthUser } from '@/store/modules/auth/getters'
import { Grade, passImages } from '@/core/Grades'
import { markGradeNotificationAsRead, GradeNotificationType } from '@/core/Me'

export const gradeUpMessages = {
  beginner: `おめでとうございます 🎉
あなたのGYYM PASSがBEGINNER PASSにランクアップしました。

お帰りなさい、また一緒に頑張りましょう📣
まずは、無理なく月1ペースからでも継続することが大切です🌟`,
  light: `おめでとうございます 🎉
あなたのGYYM PASSがLIGHT PASSにランクアップしました。

楽しく続けるコツはお友達と一緒に利用したりSNSに投稿することみたいです😄`,
  standard: `おめでとうございます 🎉
あなたのGYYM PASSがSTANDARD PASSにランクアップしました。

フィットネスが習慣化されてきてますね✨
ライフスタイルとして定着するまでもう少し！`,
  silver: `おめでとうございます 🎉
あなたのGYYM PASSがSILVER PASSにランクアップしました。

すっかりフィットネスが習慣化されましたね🌟
マンネリ化を防ぐ工夫として月に1回はいつもと違う施設やプログラムを利用している人が多いそうですので試してみてください🙌`,
  gold: `おめでとうございます 🎉
あなたのGYYM PASSがGOLD PASSにランクアップしました。

遂にここまで来ましたね🏅 GYYMではフィットネスを楽しむ皆様を応援する為に、まだまだお得なGYYM PASSをご用意しています🎫 更なるランクアップを目指してみてくださいね💪`,
  premium: `おめでとうございます 🎉
あなたのGYYM PASSがPREMIUM PASSにランクアップしました。

所有者が限定されるプレミアムシリーズに突入しましたね🎫
大切なあの人の健康の為に是非ご活用ください👬`,
  vip: `おめでとうございます 🎉
あなたのGYYM PASSがVIP PASSにランクアップしました。

フィットネス × ○○○という遊び心を取り入れた楽しみ方もVIPな貴方には似合うかもしれません🍽 週末の楽しみがグッと増えますよ🍰`,
  gyym_master: `おめでとうございます 🎉
あなたのGYYM PASSがGYYM MASTERにランクアップしました。

GYYM PASSの最高ランクまで到達しました🚀 いつもGYYMをご活用頂いてありがとうございます。最大の特典をご用意していますので、引き続きGYYMでのフィットネスをお楽しみください🌟`,
}

export default Vue.extend({
  components: {
    Button,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'GradeNotificationModal',
    },
    notificationType: {
      type: String as () => GradeNotificationType,
      default: GradeNotificationType.GRADE_UP,
    },
    grade: {
      type: Object as () => Grade | null,
      default: null,
    },
    contentTransition: {
      type: Object,
      default: () => {
        return {
          name: 'modal-content',
        }
      },
    },
    // プロフィール登録直後の表示かどうか
    isAfterProfileUpdate: {
      type: Boolean,
      default: false,
    },
  } as const,
  data() {
    return {
      isMarkedAsRead: false,
    }
  },
  computed: {
    user(): PartialAuthUser {
      return this.$store.getters['auth/user']
    },
    isGradeUp(): boolean {
      return this.notificationType === GradeNotificationType.GRADE_UP
    },
    isGradeDown(): boolean {
      return this.notificationType === GradeNotificationType.GRADE_DOWN
    },
    isQuestClear(): boolean {
      return this.notificationType === GradeNotificationType.ACHIEVEMENT
    },
    isWelcomeBack(): boolean {
      return this.notificationType === GradeNotificationType.WELCOME_BACK
    },
    passType(): string | null {
      return this.grade ? this.grade.key.replace('user_grade_', '') : null
    },
    passImage(): string {
      return this.passType ? (passImages as any)[this.passType] || '' : ''
    },
    gradeUpMessage(): string {
      return this.passType
        ? ((gradeUpMessages as any)[this.passType] || '')
            .trim()
            .replace(/\n/g, '<br />')
        : ''
    },
  },
  methods: {
    async onOpen() {
      this.pushEvent()
      this.$emit('opened')

      this.isMarkedAsRead = false
      await markGradeNotificationAsRead()
      this.isMarkedAsRead = true
    },
    onConfirm() {
      this.$modal.pop()
      this.$router.push('/me').catch((_) => {})
    },
    pushEvent() {
      if (!this.grade) return

      switch (this.notificationType) {
        case GradeNotificationType.GRADE_UP:
          pushModalRankUpEvent(this.user.id, this.grade.key)
          break
        case GradeNotificationType.GRADE_DOWN:
          pushModalRankDownEvent(this.user.id, this.grade.key)
          break
        case GradeNotificationType.ACHIEVEMENT:
          pushModalCompleteQuestEvent(this.user.id, this.grade.key)
          break
        case GradeNotificationType.WELCOME_BACK:
          pushModalWelcomeBackEvent(this.user.id, this.grade.key)
          break
        default:
          return
      }
    },
  },
})
